export default {
  install(Vue) {
    Vue.mixin({
      beforeCreate() {
        const vm = this;

        Vue.prototype.$load = async action => {
          try {
            await action();
          } catch (error) {
            if (error.response) {
              vm.$vs.notify({
                title: "Ошибка",
                text: "Не удалось получить данные",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger"
              });

              vm.$vs.loading.close();
            }
          }
        };
      }
    });
  }
};
